export default "__VITE_ASSET__8Xnr4VUK__"